import { useEffect } from "react";

export const usePageTitle = (title) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
};

export const usePageSeo = (title, description) => {
  useEffect(() => {
    document.title = title;
    if (description) {
      const el = document.querySelector('meta[name="description"]');
      if (el) el.setAttribute("content", description);
    }
  }, [title, description]);
};
